module.exports = __webpack_public_path__ + "static/img/40012 (1).39c2fc0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40012 (1).webp
// module id = 9wcw
// module chunks = 14